module.exports = __webpack_public_path__ + "static/img/shi4_1.937caa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shi4_1.png
// module id = +VzU
// module chunks = 1